module.exports = __webpack_public_path__ + "static/media/wallet.7da13112.svg";